import { atom, selector, useRecoilValue } from "recoil";

//* Set notification*/

export const notificationMsgsState = atom({
  key: "notificationMsgsState",
  default: [],
});
